import layout from '@/layout'

export default {
  path: '/user',
  component: layout,
  redirect: '/user/userStockNote',
  name: 'userStockNote',
  meta: {
    title: 'user',
    icon: 'admin'
  },
  children: [
    {
      path: '/user/userStockNote',
      name: 'userStockNote',
      component: () => import('@/views/user/user-stock-note/index.vue'),
      meta: {
        title: 'userStockNote',
        icon: 'admin'
      }
    }
  ]
}
